import ApiClient from '@src/lib/api_client'
import { API } from '@src/lib/api_path'
import SessionManager from '@src/lib/session_manager'
import { MemberActivity } from '@src/data/member-activity'
import Activity from '@src/data/activity'
import camelcaseKeys from 'camelcase-keys'

type ActivitiesResponse = {
  member_activities: Activity[],
  meta: {
    current_page: number,
    total_pages: number
  }
}

export class ActivityService {

  apiClient: ApiClient = new ApiClient()

  getPage (memberId, page, itemsPerPage, type, status?) {
    let apiPath
    let params = {
      page: page,
      items_per_page: itemsPerPage,
      with_activity_type: type || undefined,
      with_status: status
    }
    if (SessionManager.Instance.isManager()) {
      apiPath = API.TRAINERS_API.MEMBER_ACTIVITIES.replace('{memberId}', memberId)
    } else {
      apiPath = API.MEMBERS_API.MEMBER_ACTIVITIES
    }
    return this.apiClient.get<ActivitiesResponse>(apiPath, params)
      .then((response: ActivitiesResponse) => {
        return Promise.resolve({
          memberActivities: response.member_activities.map((activity: any) => new MemberActivity(camelcaseKeys(activity, { deep: true }))),
          totalPages: response.meta.total_pages
        })
      })
      .catch(error => {
        console.error('failed to retrieve activities', error)
        return Promise.reject(error)
      })
  }

  deleteActivity (activityId) {
    return this.apiClient.delete(`${API.MEMBERS_API.MEMBER_ACTIVITIES}/${activityId}`).then(() => {
      return Promise.resolve()
    }).catch(error => {
      console.error('Failed to delete activity', error)
      return Promise.reject(error)
    })

  }

  completeActivity (activityId, data) {
    return this.apiClient.put(`${API.MEMBERS_API.MEMBER_ACTIVITIES}/${activityId}`, data).then(() => {
      return Promise.resolve()
    }).catch(error => {
      console.error('Failed to complete activity', error)
      return Promise.reject(error)
    })
  }
}
